<template>
  <div class="account-register-footer">
    <div class="account-register-footer__title">Already have an account?</div>
    <span @click.prevent="onLogin" class="account-register-footer__link">
      Login to My Account
    </span>
  </div>
</template>

<script src="./footer.js"></script>
<style src="./footer.scss" lang="scss"></style>
